export const RestrictionWarningComponent = {
  templateUrl: 'components/restriction-warning/restriction-warning.html',
  transclude: true,
  controller: function RestrictionWarningController() {
    'ngInject';
    this.$onInit = () => {};
  },
};
